<template>
<div class="chapter">
<div class="inner_page">
<a id="p3"></a>
<p class="sink"> </p>
<blockquote>
<p class="hang ">Truth becomes fiction when the fiction’s true;</p>
</blockquote>
<blockquote>
<p class="hang ">Real becomes not-real where the unreal’s real.</p>
</blockquote>
<blockquote class="indent2">
<p class="hang "><em>—Cao Xueqin</em>, The Story of the Stone</p>
</blockquote>
<div class="timebreak "> </div>
<blockquote>
<p class="left ">Tell all the truth but tell it slant.</p>
</blockquote>
<blockquote class="indent2">
<p class="hang ">
<em>—Emily Dickinson</em>
</p>
</blockquote>
<div class="timebreak "> </div>
<a id="px3"></a>
<figure class="full ">
<img alt=" " id="fig_Fortunes_009_1" src="images/Fortunes_009_1.jpg"/>
</figure>
<div class="timebreak "> </div>
<blockquote class="indent2">
<p class="hang "><em>—Anon.</em>, Oriental riff</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?39b8bb68